let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k751z")).then(() => parcelRequire('gBmrb'));